import Cookies from 'js-cookie'
import { auth } from './firebase'

export function check_cookie(){
  // Test to see if there is a token in cookies
  const auth_token = Cookies.get('token')
  if (auth_token) {
    // login (will use token when it's set up)
    auth.signInWithCustomToken(auth_token)
      .then(data => this.user = data.user.uid)
      // if unsuccessfull token, log out of firebase
      .catch((error) => {
        console.log('I hit the catch')
        console.log(error)
        // this.logout()
      })
  }
  else {
    // if there is no token re-route
    console.log('I have no cookie!')
    // auth.signOut().then(()=>{
    //   this.user = false
    //   this.$router.replace('/re-route')
    // })
  }
}

export function activate_cookie_listener() {
  //create a listener to check if there is still a token present
  let setIntervalId
  const trigger = () => {
    return setInterval(()=>{
      if(!Cookies.get('token')){
        this.logout();
        clearInterval(setIntervalId);
      }
      const jwt = Cookies.get('token')
      const tokens = jwt.split(".");
      const expires = JSON.parse(atob(tokens[1])).exp
      const date = new Date();
      const time = parseInt(date.getTime()/1000)
      if(expires <= time){
        this.logout();
        clearInterval(setIntervalId);
      }
    }, 1000);
  }
  // Create a trigger Id so it can be cleared
  setIntervalId = trigger()
}
